module.exports = __webpack_public_path__ + "static/media/1_A1_13.8d935943.png";